import React, { useState } from 'react';
import { validatePassword } from 'sdk/utils/validation';
import useUpdatePassword from 'sdk/hooks/user/useUpdatePassword';
import { PassInput } from 'components/shared/Input';
import AuthModal from 'components/shared/modals/AuthModal';
import Info from 'components/shared/Info';
import Button from 'components/shared/Button';
import { StringConstant } from 'utils/Constants';
import styles from './NewPassword.module.scss';
import { ReactComponent as IconInfo2 } from 'images/info2.svg';
import { ReactComponent as Success } from 'images/new-icons/Exactly.svg';
import { Trans } from 'react-i18next';

function NewPassword({ onClose }: { onClose: () => void }) {
  const [currentPass, setCurrentPass] = useState('');
  const [pass, setPass] = useState('');
  const [pass2, setPass2] = useState('');
  const [isPassVisible, setIsPassVisisble] = useState(false);
  const [passError, setPassError] = useState(false);

  const [error, setError] = useState(false);

  const {
    isSuccess: updatePasswordSuccess,
    isError: isUpdatePasswordError,
    error: updatePasswordError,
    mutateAsync: updatePasswordMutate,
    isLoading: isUpdatePasswordLoading,
  }: any = useUpdatePassword(pass, currentPass);

  const handleCurrentPasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    setCurrentPass((e.target as HTMLInputElement).value);
    setPassError(false);
  };

  const handlePasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    setPass((e.target as HTMLInputElement).value);
    setPassError(false);
  };

  const handlePassword2Change = (e: React.FormEvent<HTMLInputElement>) => {
    setPass2((e.target as HTMLInputElement).value);
    setPassError(false);
  };

  const isPassValid = validatePassword(pass) && pass === pass2;

  React.useEffect(() => {
    if (updatePasswordError) setError(true);
  }, [updatePasswordError]);

  return (
    <AuthModal onClose={onClose} title="Change Password" showLogo>
      <PassInput
        className={styles.margin20}
        value={currentPass}
        onChange={handleCurrentPasswordChange}
        isVisible={isPassVisible}
        switchVisibility={() => setIsPassVisisble(!isPassVisible)}
        error={passError || isUpdatePasswordError}
        onBlur={() => setPassError(!currentPass)}
        placeholder="Current Password"
        wide
        white
      />
      <Info white>
        <span>
          {/* @ts-ignore */}
          <Trans i18nKey={'password_min_length' as any} components={{ em: <em /> }} />
        </span>
      </Info>
      <PassInput
        className={styles.margin20}
        value={pass}
        onChange={handlePasswordChange}
        isVisible={isPassVisible}
        switchVisibility={() => setIsPassVisisble(!isPassVisible)}
        error={passError || isUpdatePasswordError}
        onBlur={() => setPassError(!isPassValid)}
        placeholder="New Password"
        wide
        white
      />

      <PassInput
        className={styles.margin20}
        value={pass2}
        onChange={handlePassword2Change}
        isVisible={isPassVisible}
        switchVisibility={() => setIsPassVisisble(!isPassVisible)}
        error={passError || isUpdatePasswordError}
        errorMessage={
          pass === pass2 ? StringConstant.NEW_PASSWORD_ERROR : StringConstant.NEW_PASSWORD_MISMATCH
        }
        onBlur={() => setPassError(!isPassValid)}
        placeholder="Repeat Password"
        wide
        white
      />

      <Button
        className={styles.marginauto}
        disabled={!isPassValid || !currentPass}
        onClick={async () => {
          await updatePasswordMutate();
        }}
        wide
        darkGreen
        loading={isUpdatePasswordLoading}
      >
        Change Password
      </Button>

      {updatePasswordSuccess && (
        <div className={styles.success} onClick={() => onClose()}>
          <div className={styles.success__inner}>
            <Success />
            <div>Success</div>
            <div>{StringConstant.NEW_PASSWORD_SUCCESS}</div>
          </div>
        </div>
      )}
      {error && (
        <div className={styles.success} onClick={() => setError(false)}>
          <div className={styles.success__inner}>
            <IconInfo2 />
            <div>Error</div>
            <div>{StringConstant.NEW_PASSWORD_ERROR}</div>
          </div>
        </div>
      )}
    </AuthModal>
  );
}

export default NewPassword;
